import { apiClient } from "@/shared/api/apiClient";

/** Giriş öncesi (token'sız) okul kayıt başvurusu gövdesi. */
export interface SchoolRegistrationPayload {
  schoolName: string;
  managerName: string;
  managerPhone: string;
  managerEmail: string;
  schoolPhone?: string;
  schoolWebsite?: string;
}

export const schoolRegistrationApi = {
  // Public uç (SecurityConfig: POST /public/school-requests permitAll); token gerektirmez.
  submit: (payload: SchoolRegistrationPayload) =>
    apiClient.post("/public/school-requests", payload).then(() => undefined),
};
